import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/shows';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="w-9 h-9 flex items-center justify-center">
              <i className="ri-movie-2-line text-2xl" style={{ color: 'oklch(var(--primary-500))' }}></i>
            </span>
            <span className="text-xl font-heading font-bold text-foreground-900">
              天狼影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-2 text-sm font-medium text-foreground-600 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 space-y-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors duration-200 cursor-pointer"
              >
                <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
                  <i className={`${cat.icon} text-base`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-background-200/60 pt-2 mt-2">
              <Link
                to="/about"
                className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors duration-200 cursor-pointer"
              >
                <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
                  <i className="ri-information-line text-base"></i>
                </span>
                关于我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}